const moment = require('moment');



const esBisiesto = (year) => {
    return (year % 400 === 0) ? true : 
                (year % 100 === 0) ? false : 
                    year % 4 === 0;
};

function range(start, stop, step) {
    if (typeof stop == 'undefined') {
        // one param defined
        stop = start;
        start = 0;
    }

    if (typeof step == 'undefined') {
        step = 1;
    }

    if ((step > 0 && start >= stop) || (step < 0 && start <= stop)) {
        return [];
    }

    var result = [];
    for (var i = start; step > 0 ? i < stop : i > stop; i += step) {
        result.push(i);
    }

    return result;
};


function DatosDias(mes, anio){

    if (mes == "Enero" || mes == "Marzo" || mes == "Mayo" || mes == "Julio" || mes == "Agosto" || mes == "Octubre" || mes == "Diciembre")
    {

        let dias = range(1, 32, 1);
        return dias;

    } else {


        if (mes == "Febrero")
        {

            if (esBisiesto(anio))
            {

                let dias = range(1, 30, 1);
                return dias;


            } else {

                let dias = range(1, 29, 1);
                return dias;


            }



        } else {

            let dias = range(1, 31, 1);
            return dias;

        }


    }



};


function saberNumeroMes(numeroMes){

    var numeroMes = parseInt(numeroMes);

    let meses= [
          "Enero", 
          "Febrero",
          "Marzo",
          "Abril",
          "Mayo",
          "Junio",
          "Julio",
          "Agosto",
          "Septiembre",
          "Octubre",
          "Noviembre", 
          "Diciembre"
        ];



    var index = (numeroMes-1);



    return meses[index];

}


function saberMesNumero(mes){


    let meses= [
          "Enero", 
          "Febrero",
          "Marzo",
          "Abril",
          "Mayo",
          "Junio",
          "Julio",
          "Agosto",
          "Septiembre",
          "Octubre",
          "Noviembre", 
          "Diciembre"
        ];

    var index = 1;

    for (let mesecito of meses)
    {
        
        if (mesecito == mes)
        {

            return index;

        } else {

            var index = (index+1);

        }

    }

    return 24;

}


function pintarFecha(fecha){

    let fechaBuena = moment(String(fecha), "YYYY-MM-DD");

    let month = fechaBuena.format('M');
    let day   = fechaBuena.format('D');
    let year  = fechaBuena.format('YYYY');


    let month2 = saberNumeroMes(month);


    let fechaGood = {

        day: parseInt(day),
        month: month2,
        year: parseInt(year)

    };

    return fechaGood;


}



function pintarFechaMasCercanaAsisaSalud(fecha){


    let fechaBuena = moment(String(fecha), "YYYY-MM-DD");

    let month = fechaBuena.format('MM');
    let day   = fechaBuena.format('DD');
    let year  = fechaBuena.format('YYYY');


    if (parseInt(day) <= 5)
    {

        let fechaGood = year+"-"+month+"-01";
        return fechaGood;


    } else {


        if (parseInt(day) <= 15)
        {

            let fechaGood = year+"-"+month+"-15";
            return fechaGood;

        } else {


            if (parseInt(day) <= 20)
            {
    
                let fechaGood = year+"-"+month+"-15";
                return fechaGood;

            } else {

                let fechaproximomes = fechaBuena.add(17, 'days');

                let monthNew = fechaproximomes.format('MM');
                let yearNew  = fechaproximomes.format('YYYY');
    
                let fechaGood = yearNew+"-"+monthNew+"-01";
                return fechaGood;    

            }
    

        }


    }


}



function CalcularMatrizAnios(fechaMin, fechaMax){


    let fechaBuenaMin = moment(new Date(fechaMin), "YYYY-MM-DD");
    let yearMin  = parseInt(fechaBuenaMin.format('YYYY'));


    let fechaBuenaMax = moment(new Date(fechaMax), "YYYY-MM-DD");
    let yearMax  = parseInt(fechaBuenaMax.format('YYYY'));    


    let anios = range(yearMin, (yearMax+1), 1);

    return anios;


}

function convertirFecha(fecha){

    let year = fecha.year;
    let month = fecha.month;
    let day = fecha.day;


    let month2 = saberMesNumero(month);


    let fecha2 = year+'-'+month2+'-'+day;

    let fechaBuena = moment(String(fecha2), "YYYY-MM-DD");

    return fechaBuena;

}


function guardarFecha(fecha){

    let year = fecha.year;
    let month = fecha.month;
    let day = fecha.day;

    let month2 = saberMesNumero(month);

    let fecha2 = year+'-'+month2+'-'+day;

    let fechaBuena = moment(String(fecha2), "YYYY-MM-DD");

    let fechaBuena2 = fechaBuena.format("YYYY-MM-DD");

    return fechaBuena2;

}


function validarFecha(fechaMin, fechaMax, fechaActual){


    let fechaBuena = convertirFecha(fechaActual);
    let fechaMin2 = moment(new Date(fechaMin), "YYYY-MM-DD");
    let fechaMax2 = moment(new Date(fechaMax), "YYYY-MM-DD");

    if (fechaBuena >= fechaMin2 && fechaBuena <= fechaMax2)
    {

        return true;

    } else {

        return false;

    }

}





exports.DatosDias = DatosDias;
exports.pintarFecha = pintarFecha;
exports.CalcularMatrizAnios = CalcularMatrizAnios;
exports.convertirFecha = convertirFecha;
exports.validarFecha = validarFecha;
exports.guardarFecha = guardarFecha;
exports.pintarFechaMasCercanaAsisaSalud = pintarFechaMasCercanaAsisaSalud;